import { InputLabel, MenuItem, Select, SelectProps } from "@material-ui/core";
import React, { useState } from "react";

type DefaultProps<T> = {
    disabled?: boolean;
    value: T;
    options: T[];
    inputLabel: string;
    SelectProps?: SelectProps;
    className?: string;
    onChange?: (value: T | undefined) => void;
    getOptionLabel?: (value: T) => string;
    displayOptions?: (options: T[]) => JSX.Element[];
    marginTop?: number
};

export function CustomSelect<T extends object>(
    props: DefaultProps<T> & {
        getOptionValue: (opt: T) => string;
    }
): JSX.Element;
export function CustomSelect<T extends string>(
    props: DefaultProps<T> & {
        getOptionValue?: (opt: T) => string;
    }
): JSX.Element;
export function CustomSelect<T extends object | string>(
    props: DefaultProps<T> & {
        getOptionValue?: (opt: T) => string;
    }
) {
    const {
        value,
        getOptionLabel,
        options,
        SelectProps,
        getOptionValue,
        inputLabel,
        onChange,
        disabled,
        marginTop = 10
    } = props;

    const [initialValue, setInitialValue] = useState<string | null>(typeof value === "string" ? value : getOptionValue!(value));

    return (
        <>
            <InputLabel style={{ marginTop: marginTop + "px" }}>{inputLabel}</InputLabel>
            <Select
                {...SelectProps}
                fullWidth
                disabled={disabled}
                value={initialValue}
                onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                    setInitialValue(event.target.value as string);
                    onChange &&
                        onChange(
                            options.find(
                                (el) => el === (event.target.value as T)
                            )
                        );
                }}
            >
                {options.map((item, index) => {
                    const value =
                        typeof item === "string" ? item : getOptionValue!(item);
                    return (
                        <MenuItem value={value} key={index}>
                            {getOptionLabel ? getOptionLabel(item) : item}
                        </MenuItem>
                    );
                })}
            </Select>
        </>
    );
}
